import * as React from "react";

import theme from "@ui/themes/default";

import { style, Icon } from "./Symbolicons";

export const Dots = (props: Icon): React.ReactElement => (
  <svg
    style={{ ...style(props.size, props.height), ...props.style }}
    className={props.className}
    viewBox="0 0 28 30"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14 11a3 3 0 100 6 3 3 0 000-6zm-9 0a3 3 0 100 6 3 3 0 000-6zm18 0a3 3 0 100 6 3 3 0 000-6z"
      fill={props.color || theme.palette.grey600}
      fillRule="nonzero"
    />
  </svg>
);
